<template>
  <jt-card-default
    :shouldShowSelectMonth="false"
    :cardSelectType="0"
    @change="onChangeSelectBar"
  >
    <div v-if="isLoadingBar" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-bar-chart
      v-else
      centralTitleConst="DASHBOARD_BILLING_CUSTOMERS_ATTENDED"
      class="editCss"
      :data="collectionsSpecialComunData"
      :xAxisData="collectionsSpecialComunColumn"
      :shouldShowOverlappingBars="true"
      :horizontalBar="false"
    />
  </jt-card-default>
</template>

<script>
import JtBarChart from 'src/components/charts/JtBarChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'CustomersAttended',
  components: {
    JtCardDefault,
    JtBarChart
  }
})
export default class CustomersAttended extends Vue {
  isLoadingBar = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  doughnutData = [];
  collectionsSpecialComunColumn = [];
  collectionsSpecialComunData = [];

  async onChangeSelectBar (newValue) {
    this.isLoadingBar = true

    this.doughnutData = await this.getDoughnutData(newValue)

    this.collectionsSpecialComunData = [
      {
        data: this.doughnutData.map((register) => register.value),
        name: this.$gettext('DASHBOARD_BILLING_CUSTOMERS_ATTENDED')
      }
    ]

    this.collectionsSpecialComunColumn = this.doughnutData.map(
      // (register) => register.label
      (register) => moment(register.label, 'MM').format('MMM')
    )

    setTimeout(() => {
      this.isLoadingBar = false
    }, 500)
  }

  async created () {
    await this.onChangeSelectBar(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'customersAttended',
        year: date.year
      }
    )

    const data = registros.map((registro) => {
      return {
        label: registro.month,
        value: registro.counts
      }
    })

    return data
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
